import type { ReactElement } from 'react'

import { Button } from '@/components/ui/button'

export function RouteErrorFallback(): ReactElement {
  function handleReload() {
    window.location.reload()
  }

  return (
    <div role="alert" className="flex min-h-screen flex-col items-center justify-center gap-4 p-6">
      <div className="space-y-2 text-center">
        <h1 className="text-2xl font-semibold">Algo deu errado</h1>
        <p className="text-sm text-muted-foreground">
          Tente recarregar a pagina. Se persistir, contate o suporte.
        </p>
      </div>
      <Button onClick={handleReload} className="min-h-[44px]">Recarregar pagina</Button>
    </div>
  )
}
